import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { KeeniconComponent } from '../keenicon/keenicon.component';

@Component({
  selector: 'ui-alert',
  imports: [NgClass, KeeniconComponent],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[attr.data-cy]': 'dataCy() || null' },
})
export class AlertComponent {
  dataCy = input<string>('');
  severity = input<string>('info');
  class = input<string>('');
  icon = input<string>('information');
  iconClass = input<string>('fs-3');
}
